<div class="dialog-container">
  <mat-card class="header-card de-h3" fxLayout="row"
    >PAR Notifications
  </mat-card>
  <div class="notification-container">
    <div class="manager-display-name">
      <span>Showing Notifications For: </span>
      <span class="name-manager">{{ currentManagerName }}</span>
    </div>

    <div class="display-notifications">
      <div class="spinner-container" *ngIf="notificationLoading">
        <div class="progress-spinner">
          <mat-progress-spinner
            mode="indeterminate"
            color="primary"
          ></mat-progress-spinner>
        </div>
      </div>
      <div *ngIf="!notificationLoading" class="notification-list">
        <div class="list">
          <!-- No Notifications -->
          <div class="items" *ngIf="noNotification">
            <div class="left-align-list" (click)="closeDialog()">
              <mat-icon class="icon-size" svgIcon="alert-base"></mat-icon>
              <div class="notification-text">
                <span>No New Notifications At This Time.</span>
              </div>
            </div>
          </div>

          <!-- Unallocated Workers Notification -->
          <div class="items" *ngIf="unallocatedNotification">
            <div
              class="left-align-list"
              (click)="closeDialog()"
              [routerLink]="'/worker/dashboard/'"
              [queryParams]="{ worker_type: 'unassigned' }"
              matTooltip="Navigate To Source"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-size" svgIcon="alert-base"></mat-icon>
              <div class="notification-text">
                <span>You have workers that are unallocated.</span>
              </div>
            </div>
            <div class="clear-notification">
              <button
                (click)="clearUnallocated()"
                matTooltip="Clear Notification"
                matTooltipPosition="above"
              >
                Clear
              </button>
            </div>
          </div>

          <!-- Incorrect Charge Notification -->
          <div class="items" *ngIf="chargingNotification">
            <div
              class="left-align-list"
              (click)="closeDialog()"
              [routerLink]="'/reports/cap-om-report'"
              matTooltip="Navigate To Source"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-size" svgIcon="alert-base"></mat-icon>
              <div class="notification-text">
                <span>You have workers charging to incorrect codes.</span>
              </div>
            </div>
            <div class="clear-notification">
              <button
                (click)="clearCharging()"
                matTooltip="Clear Notification"
                matTooltipPosition="above"
              >
                Clear
              </button>
            </div>
          </div>

          <!-- Over Tolerance On CAP/OM Variance -->
          <div class="items" *ngIf="varianceNotification">
            <div
              class="left-align-list"
              (click)="closeDialog()"
              [routerLink]="'/reports/cap-om-report'"
              matTooltip="Navigate To Source"
              matTooltipPosition="above"
            >
              <mat-icon class="icon-size" svgIcon="alert-base"></mat-icon>
              <div class="notification-text">
                <span>You have workers with high CAP/OM Variance.</span>
              </div>
            </div>
            <div class="clear-notification">
              <button
                (click)="clearVariance()"
                matTooltip="Clear Notification"
                matTooltipPosition="above"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="close-dialog">
      <button
        (click)="closeDialog()"
        matTooltip="Close Dialog"
        matTooltipPosition="above"
      >
        Close
      </button>
    </div>
  </div>
</div>
